import { EntityImage } from '@tribeplatform/react-components/common/components'
import { useResolvedHref } from '@tribeplatform/react-components/Link'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { BC } from '../../types/index.js'
import { useMobileMenu } from '../Navbar/providers/MobileMenuProvider.js'

import { LinkMenuItem, LinkMenuProps } from './types.js'

const LinkMenuLeaf = ({
  item,
  Link,
  pathname,
  onClose,
}: {
  item: LinkMenuItem
  Link: ReturnType<typeof useRouter>['Link']
  pathname: string
  onClose: () => void
}) => {
  // item.href may be a space:// token; resolve it before comparing to the
  // current path, otherwise active highlighting never matches.
  const resolvedHref = useResolvedHref(item?.href)

  let isActive = false
  if (resolvedHref) {
    if (resolvedHref === '/') {
      isActive = pathname === resolvedHref
    } else {
      isActive = pathname?.indexOf(resolvedHref) === 0
    }
  }

  return (
    <NavVertical.Item
      variant="inherit"
      as={Link}
      href={item?.href}
      target={item?.openInNewWindow ? '_blank' : '_self'}
      active={isActive}
      leadingIcon={
        <div className="-ms-1 me-3 w-6 h-6 flex-shrink-0 flex items-center justify-center">
          <EntityImage
            size="lg"
            entity={{ image: item?.image, name: item?.text }}
          />
        </div>
      }
      onClick={onClose}
    >
      {item?.text}
    </NavVertical.Item>
  )
}

export const LinkMenuBlock: BC<LinkMenuProps> = ({ items, title, ...rest }) => {
  const { Link } = useRouter()
  const { close } = useMobileMenu()
  const pathname = useRouterPath()
  if (!items) {
    return null
  }

  return (
    <NavVertical {...rest} aria-label={title || rest['data-block-id']}>
      <NavVertical.Group>
        {!!title && <NavVertical.GroupHeader>{title}</NavVertical.GroupHeader>}
        {items.map(item => (
          <LinkMenuLeaf
            key={item?.text}
            item={item}
            Link={Link}
            pathname={pathname}
            onClose={close}
          />
        ))}
      </NavVertical.Group>
    </NavVertical>
  )
}
